import React, { useEffect } from 'react';
import CustomHeader from '../components/CustomHeader';

function OpenSourceInfraPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="subcustom-header-container">
      <CustomHeader />
      <header className="subcustom-header">
        <div className="hero-title-area">
          <div className="hero-subtitle">OPENSOURCE INFRASTRUCTURE</div>
          <h2 className="hero-title">오픈소스 인프라</h2>
        </div>
      </header>
      <div className="breadcrumb">
        <span>Home</span>
        <span>오픈소스 인프라 소프트웨어</span>
      </div>
      <div className="infra-main">
      <h3 className="infra-title">오픈소스 IT인프라 소프트웨어</h3>
      <hr className="infra-divider" />
      <section className="infra-section">
        <div className="infra-info">
          <div className="infra-label">OS</div>
          <h4 className="infra-section-title">운영체제</h4>
          <div className="infra-list-wrap">
            <ul className="infra-list">
              <li>Rocky Linux</li>
            </ul>
          </div>
        </div>
        <div className="infra-img">
          <img src="/test_img.png" alt="OS 이미지" />
        </div>
      </section>
      <section className="infra-section">
        <div className="infra-info">
          <div className="infra-label">Middleware</div>
          <h4 className="infra-section-title">미들웨어</h4>
          <div className="infra-list-wrap">
            <ul className="infra-list">
              <li>Apache Tomcat</li>
              <li>Nginx</li>
              <li>WildFly</li>
              <li>ClusterPlex</li>
            </ul>
          </div>
        </div>
        <div className="infra-img">
          <img src="/test_img.png" alt="미들웨어 이미지" />
        </div>
      </section>
      <section className="infra-section">
        <div className="infra-info">
          <div className="infra-label">DB</div>
          <h4 className="infra-section-title">오픈소스 데이터베이스</h4>
          <div className="infra-list-wrap">
            <ul className="infra-list">
              <li>mySql</li>
              <li>MariaDB</li>
              <li>PostgreSql</li>
            </ul>
          </div>
        </div>
        <div className="infra-img">
          <img src="/test_img.png" alt="DB 이미지" />
        </div>
      </section>
      </div>
    </div>
  );
}

export default OpenSourceInfraPage; 